import {
  Box,
  Card,
  CardContent,
  Container,
  Grid,
  Typography,
} from '@mui/material'
import React, { useState } from 'react'
import { useAuth } from 'react-oidc-context'
import { AppAPIClient } from '../lib/index'

const UnauthenticatedLanding = () => {
  const auth = useAuth()
  const [api] = useState(new AppAPIClient(auth))

  const handleRedeemPerks = () => {
    api.trackAnalytics('CLICKED_LANDING_CTA', { action: 'redeem_perks' })

    // Redirect to Keycloak login
    auth.signinRedirect()
  }

  const handleSubmitPerk = () => {
    api.trackAnalytics('CLICKED_LANDING_CTA', { action: 'submit_perk' })

    // Redirect to external perks submission form
    window.open(
      'https://perks.techstars.com/perks/s/',
      '_blank',
      'noopener,noreferrer',
    )
  }

  return (
    <Container maxWidth="md">
      <Box sx={{ py: 8, textAlign: 'center' }}>
        <Typography variant="h3" component="h1" gutterBottom>
          Welcome to Techstars Perks
        </Typography>
        <Typography variant="h6" color="text.secondary" sx={{ mb: 6 }}>
          Choose how you'd like to get started
        </Typography>

        <Grid container spacing={4} justifyContent="center">
          <Grid item xs={12} sm={6} md={5}>
            <Card
              sx={{
                cursor: 'pointer',
                height: '100%',
                '&:hover': {
                  boxShadow: 6,
                  transform: 'translateY(-2px)',
                },
                transition: 'all 0.2s ease-in-out',
              }}
              onClick={handleSubmitPerk}
            >
              <CardContent sx={{ p: 4, textAlign: 'center' }}>
                <Typography variant="h5" component="h2" gutterBottom>
                  Submit a Perk
                </Typography>
                <Typography variant="body1" color="text.secondary">
                  Are you a partner looking to offer perks to Techstars
                  companies? Submit your perk offer here.
                </Typography>
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={12} sm={6} md={5}>
            <Card
              sx={{
                cursor: 'pointer',
                height: '100%',
                '&:hover': {
                  boxShadow: 6,
                  transform: 'translateY(-2px)',
                },
                transition: 'all 0.2s ease-in-out',
              }}
              onClick={handleRedeemPerks}
            >
              <CardContent sx={{ p: 4, textAlign: 'center' }}>
                <Typography variant="h5" component="h2" gutterBottom>
                  Redeem Perks
                </Typography>
                <Typography variant="body1" color="text.secondary">
                  Are you a Techstars entrepreneur? Sign in to browse and redeem
                  exclusive perks for your company.
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Box>
    </Container>
  )
}

export default UnauthenticatedLanding
